export default __webpack_public_path__ + "static/media/capitual-brand.d85145e3.svg";